/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} App_Opening_WorkspaceInputs */

const fr_app_opening_workspace = /** @type {(inputs: App_Opening_WorkspaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ouverture de l’espace de travail…`)
};

const en_app_opening_workspace = /** @type {(inputs: App_Opening_WorkspaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opening workspace…`)
};

/**
* | output |
* | --- |
* | "Opening workspace…" |
*
* @param {App_Opening_WorkspaceInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const app_opening_workspace = /** @type {((inputs?: App_Opening_WorkspaceInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<App_Opening_WorkspaceInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_app_opening_workspace(inputs)
	return fr_app_opening_workspace(inputs)
});